import cloneDeep from 'lodash/cloneDeep'

export const translateFormToSimulationPlan = form => {
  const simulationPlan = translateSimulationPlan(form)
  const menuSetting = translateMenuSetting(form)
  return {
    simulationPlan,
    menuSetting,
  }
}

const translateMenuSetting = form => {
  const menuSetting = form.deliverySetting.menuSetting
  const customLocationGroups = menuSetting.simulationCustomLocationGroups.simulationLocationGroups.map(
    removeTemporaryPropsForCustomGroup,
  )
  const poiLocationGroups = menuSetting.simulationPoiLocationGroups.simulationLocationGroups.map(
    removeTemporaryPropsForPoiGroup,
  )
  return {
    ...menuSetting,
    simulationCustomLocationGroups: customLocationGroups,
    simulationPoiLocationGroups: poiLocationGroups,
    /** @deprecated API修正後削除する */
    useLowQualityLocation: true,
  }
}

const translateSimulationPlan = from => {
  const { basicSetting, advancedSetting } = from
  const { ownerProfileMenu, menus } = basicSetting
  const menu = menus.find(m => m.id === ownerProfileMenu.id)

  return {
    id: basicSetting.id,
    simulationPlanMenuPost: {
      originOwnerProfileMenuId: ownerProfileMenu.id,
      agencyMargin: ownerProfileMenu.agencyMargin,
      menuName: menu.name,
      menuType: menu.menuType,
      unitType: menu.unitType,
      grossPrice: menu.grossPrice,
      costPlusMarginPercentage: menu.costPlusMarginPercentage,
      deliveryTargets: menu.deliveryTargets,
      currency: menu.currency,
    },
    name: basicSetting.name,
    menuType: menu.MenuType,
    agencyId: basicSetting.agencyId,
    advertiserId:
      basicSetting.selectedAdvertiser !== undefined
        ? basicSetting.selectedAdvertiser.id
        : undefined,
    creativeType: basicSetting.ownerProfileMenu.creativeType,
    creativeSetting: basicSetting.creativeSetting,
    deliveryDays: basicSetting.deliveryDays,
    useAdvancedSetting: advancedSetting.useAdvancedSetting,
    advancedSetting: {
      deliveryDevices: advancedSetting.deliveryDevices,
      deliveryInventories: advancedSetting.deliveryInventories,
      onlyJapaneseDevice: advancedSetting.onlyJapaneseDevice,
      deliveryTimeSchedules: removeTemporaryPropsForSchedules(
        advancedSetting.deliveryTimeSchedules,
      ),
      age: advancedSetting.demographicSetting.age,
      marriage: advancedSetting.demographicSetting.marriage,
      sex: advancedSetting.demographicSetting.sex,
    },
  }
}

/**
 * フロント側で一時利用したプロパティを削除する
 */
const removeTemporaryPropsForCustomGroup = group => {
  group.simulationLocations = removeTemporaryPropsForLocation(group)

  if (group.added) {
    delete group.id
  }
  delete group.added
  return group
}

// poiグループは地点が必要ない
const removeTemporaryPropsForPoiGroup = group => {
  const cloneGroup = cloneDeep(group)
  if (cloneGroup.added) {
    delete cloneGroup.id
  }
  delete cloneGroup.added
  // simulationLocationsを取り除く
  delete cloneGroup.simulationLocations

  // conditonsのtypeが'selet'→valueIds,'number'→valueが必要
  cloneGroup.conditions.forEach(condition => {
    if (condition.type === 'select') {
      delete condition.condition
      delete condition.value
    } else {
      delete condition.valueIds
    }
  })

  // conditionsが実質空の時
  if (cloneGroup.isPoiSearchConditionsEmpty()) cloneGroup.conditions = []

  // administrativeDistrictTypeに応じたオブジェクトを送る
  cloneGroup.area = {
    [cloneGroup.administrativeDistrictType + 'AreaObj']: cloneGroup['area'][
      cloneGroup.administrativeDistrictType + 'AreaObj'
    ],
  }
  return cloneGroup
}

// 地点グループでRequestに不要なプロパティを削除する
const removeTemporaryPropsForLocation = group => {
  return group.simulationLocations.map(location => {
    if (location.added) {
      delete location.id
      delete location.added
      return location
    }
    return location
  })
}

// 配信時間帯でRequestに不要なプロパティを削除する
const removeTemporaryPropsForSchedules = deliveryTimeSchedules => {
  return deliveryTimeSchedules.map(({ startHour, endHour }) => ({
    startHour,
    endHour,
  }))
}
